<template>
  <div class="row">
    <div class="col-sm-12">
      <md-card>
        <md-card-header>
          <div class="md-title">{{ gridTitle }}</div>
          <!-- <div class="md-subhead">Definir metas.</div> -->
        </md-card-header>

        <md-card-content>
          <div class="row">
            <div class="col-sm-12">
              <button class="btn btn-success" @click.stop.prevent="$emit('add', {})">
                <i class="fa fa-plus"></i> Adicionar
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">&nbsp;</div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <md-tooltip md-direction="top">Descrição da meta (Campo obrigatório)</md-tooltip>
              <b>Descrição</b>
            </div>
            <div class="col-sm-2">
              <md-tooltip md-direction="top">Meta a ser alcançada no perído</md-tooltip>
              <b>Meta <span class="color-red">*</span></b>
            </div>
            <div class="col-sm-3">
              <md-tooltip md-direction="top">Data inicial da meta (Obrigatório)</md-tooltip>
              <b>
                Data Inicial
                <span class="color-red">*</span>
              </b>
            </div>
            <div class="col-sm-3">
              <md-tooltip md-direction="top">Data final da meta (Campo obrigatório)</md-tooltip>
              <b>
                Data Final
                <span class="color-red">*</span>
              </b>
            </div>
            <div class="col-sm-1"></div>
          </div>
            
            <div class="row" v-for="(item, k) of items" :key="k">
              <div class="col-sm-3">
                <input
                  type="text"
                  class="form-control"
                  v-model="item.description"
                  placeholder="Descrição"
                />
              </div>
              <div class="col-sm-2">
                <input
                  type="text"
                  class="form-control text-center"
                  v-model="item.goal"
                  placeholder="Meta"
                  @input="item.goal = item.goal.replace(/\D/, '')"
                />
              </div>
              <div class="col-sm-3">
                <date-picker
                  v-model="item.date_init"
                  lang="pt-br"
                  format="DD/MM/YYYY"
                  placeholder="Data de início"
                  :not-after="item.date_end"
                  :not-before="items[ items.length -  2 ] ? items[ items.length -  2 ].date_end : ''"
                ></date-picker>
              </div>
              <div class="col-sm-3">
                <date-picker
                  v-model="item.date_end"
                  lang="pt-br"
                  format="DD/MM/YYYY"
                  placeholder="Data final"
                  :not-before="item.date_init"
                ></date-picker>
              </div>
              <div class="col-sm-1">
                <button class="btn btn-warning" @click.stop.prevent="delGoal( item )">
                  <!-- <md-tooltip md-direction="top">Remover</md-tooltip> -->
                  <i class="fa fa-minus"></i>
                </button>
              </div>
            </div>
        
        </md-card-content>
          <div class="row">
            <div class="col-sm-12">
              <span class="color-red-size">
                Os dados das metas serão efetivados após o clique no botão <b>salvar</b>
              </span>
            </div>
          </div>
        <!-- <md-card-actions>
          <md-button class="md-primary">Adicionar</md-button>
          <md-button>Action</md-button>
        </md-card-actions>-->
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    gridTitle: {
      type: String,
      default: "Metas"
    },
    items: {
      type: Array,
      default: [{}]
    }
  },
  methods: {
    delGoal(item) {
      this.items.splice(this.items.indexOf(item), 1);
      this.$notify.success("Removido com sucesso! As informações serão efetivadas ao clicar no botão SALVAR.");
    },
    addGoal(item) {
      this.$emit("pushLine", {});
    }
  }
};
</script>
<style scoped>
.color-red {
  color: #f00;
}

.color-red-size {
  color: #f00;
  padding:5px;
  font-size:10px;
}

.col-header {
  background: rgb(red, green, blue);
  height: 25px;
  color: #fff;
}

.error_date {
  border: 2px solid salmon;
  border-radius: 5px;
  padding: 5px;
}
</style>